export const en = {
    parking:{
        list: {

        },
        page: {
            slotInfo: {
                allCategories: 'All',
                category: 'Category',
                occupiedSlots: 'Busy Slots',
                parkingSlots: 'Parking Slots',
                freeSlots: 'Free Slots',
                total: 'Total'
            },
            categoryChange: {
                title: 'Change category of Slot %{slotName}',
                category: {
                    label: 'Category',
                    placeholder: 'Pick a category'
                },
                success: {
                    title: "Category changed",
                    text: "Parking slot category changed successfully"
                },
                error: 'Impossible to change category',
                submit: 'Save',
                cancel: 'Cancel'
            },
            graph: {
                numberOfSlots: '% of slots'
            }
        },
        table: {
            name: 'Slot Name',
            number: 'Slot Number',
            slot: 'Slot',
            slotId: 'Slot',
            parkingFloor: 'Floor',
            status: 'Status',
            timestamp: 'Last Update',
            category: 'Category'
        },
        categories: {
            regular: "Regular",
            mobility: "Mobility",
            noCategory: "N/A"
        },
        status: {
            free: "Free",
            busy: "Busy",
            occupied: "Occupied",
            occupiedAvg: "Occupation Average"
        },
        search: {
            placeholders: {
                slot: 'Slot',
                slotId: 'Slot',
                name: 'Insert name',
                number: 'Insert number',
                parkingFloor: 'Floor',
                status: 'Status',
                category: 'Category',
                startTime: 'Select a start date',
                endTime: 'Select an end date Day',
                startWorkingHours: 'Select starting working hours',
                endWorkingHours: 'Select ending working hours'
            },
            labels: {
                startTime: 'From Day',
                endTime: 'To Day',
                startWorkingHours: 'Working Hours From',
                endWorkingHours: 'Working Hours End'
            },
            fields: {
                parking: {
                    label: 'Parking',
                    placeholder: 'Select parking'
                },
                floor: {
                    label: 'Floor',
                    placeholder: 'Select floor'
                },
                status: {
                    label: 'Status',
                    placeholder: 'Select status'
                }
            }
        },
        permissions: {
            PARKING: "Parking",
            READ_PARKING: "Read Parking",
            CREATE_PARKING: "Create Parking",
            UPDATE_PARKING: "Update Parking",
            DELETE_PARKING: "Delete Parking"
        }
    },
};